/** Lifecycle order: Planned → Active → On hold → Finished */
export enum Status {
    planned = "Planned",
    active = "Active",
    on_hold = "On hold",
    archived = "Finished"
}

/** public: everyone; hidden: signed-in viewers + admin; personal: admin only */
export enum Visibility {
    public = "public",
    hidden = "hidden",
    personal = "personal"
}

export interface Project {
    name: string;
    status: Status;
    id: string;
    short_description: string;
    long_description?: string;
    /** Cover image; shown first in the detail carousel when set. */
    imageUrl?: string;
    /** Additional image URLs in order; merged after cover without duplicates. */
    imageUrls?: string[];
    /** Defaults to public when missing in Firestore (legacy documents). */
    visibility?: Visibility;
    startDate?: Date;
    endDate?: Date | undefined;
    /** Predefined categories (see `PROJECT_CATEGORIES`). */
    categories?: string[];
    tags?: string[];
}